import NiceModal from '@ebay/nice-modal-react'
import dynamic from 'next/dynamic'

import styles from './toolbar-mobile.module.scss'
import { SaveButton } from '@/components/atomic/SaveButton'
import { Button, ButtonHierarchy } from '@/components/styleguide/Button'
import { constants, FILTER_LEASE_TYPES_PERSONAL } from '@/lib/constants'
import { addVatToPrice } from '@/lib/utilities/search'
import { addToDataLayer, generateVehicleLink } from '@/lib/utilities/vehicle'
import { Size } from '@/types/system'

const ShareModal = dynamic(() => import('@/components/modals/ShareModal'), { ssr: false })

export const ShareAndSave = ({ onNavigationButtonClick, selectedVehiclePrice }) => {
  const monthlyPrice =
    selectedVehiclePrice.leaseType === FILTER_LEASE_TYPES_PERSONAL
      ? addVatToPrice(selectedVehiclePrice.monthlyPayment.toFixed(2))
      : selectedVehiclePrice.monthlyPayment.toFixed(2)
  const configUrlPath = `${process.env.NEXT_PUBLIC_URL}${generateVehicleLink(
    selectedVehiclePrice,
    'config',
  )}`

  const handleAppClick = platform => {
    addToDataLayer({
      event: 'social-media-share',
      platform: platform,
    })
  }

  const toggleShareDealModal = () => {
    if (onNavigationButtonClick) {
      onNavigationButtonClick(constants.configPageSections.OVERVIEW)
    }
    NiceModal.show(ShareModal, {
      title: 'Share this vehicle',
      emailSubject: `${selectedVehiclePrice.manufacturerName} ${selectedVehiclePrice.modelName} deal on LeaseLoco`,
      quote: `I've just found this ${selectedVehiclePrice.manufacturerName} ${selectedVehiclePrice.modelName} for £${monthlyPrice} per month on LeaseLoco. Check it out: `,
      onAppClick: platform => handleAppClick(platform),
      linkToShare: configUrlPath,
    })
  }

  const onCreatePriceAlert = () => {
    if (onNavigationButtonClick) {
      onNavigationButtonClick(constants.configPageSections.OVERVIEW)
    }
  }

  return (
    <div className={styles['toolbar-sub']}>
      <Button
        hierarchy={ButtonHierarchy.BezeledGray}
        size={Size.Large}
        hasBackground={false}
        onClick={toggleShareDealModal}
        icon="Share"
      />
      <SaveButton
        includeText={false}
        selectedVehiclePrice={selectedVehiclePrice}
        size={Size.Large}
        onClick={onCreatePriceAlert}
        hierarchy={ButtonHierarchy.BezeledGray}
        hasBackground={false}
      />
    </div>
  )
}
